import { Suspense } from 'react';
import { css } from '@emotion/react';
import styled from '@emotion/styled';
import DartItem from '~/components/Store/DartItem';
import DartReward from '~/components/Store/DartReward';
import { FlexStack, Icon } from '~/components/atomic';
import { DartRewardContainer } from '~/components/atomic/Skeleton';
import { FullScreenLoading, IconButtonWrapper } from '~/components/common';
import { usePurchaseDart } from '~/features/dart';
import { PaymentData } from '~/hooks/useDartInAppFlutter';
import DartBannerImage from '~/assets/img/dart/banner.png';
import DartImg from '~/assets/img/icons/dart.svg';
import { DartBalance } from '../../Header/Header.styled';

const DART_ITEM: PaymentData[] = [
  {
    id: 'dart_099',
    count: 100,
    price: 0.99,
  },
  {
    id: 'dart_499',
    count: 550,
    price: 4.99,
  },
];

export default function DartBottomSheetInner({
  onClose,
  dart,
}: {
  onClose: () => void;
  dart: number;
}) {
  const { handlePurchase, isVerifying } = usePurchaseDart();

  return (
    <>
      {isVerifying && <FullScreenLoading />}
      <Container>
        <TopContainer>
          <IconButtonWrapper onClick={onClose} style={{ width: 'fit-content' }}>
            <Icon size={24} iconName={'Close'} />
          </IconButtonWrapper>
          <DartContainer>
            <DartIcon src={DartImg} alt='' />
            <DartBalance>{dart}</DartBalance>
          </DartContainer>
        </TopContainer>
        <DartBannerBox>
          <DartBanner src={DartBannerImage} alt='store_image' />
        </DartBannerBox>
        <FlexStack spacing={24}>
          <div>
            <SubTitle>Reward</SubTitle>

            <DartPackageList>
              <Suspense fallback={<DartRewardContainer />}>
                <DartReward />
              </Suspense>
            </DartPackageList>
          </div>
          <div>
            <SubTitle>Buy</SubTitle>

            <DartPackageList>
              {DART_ITEM.map(({ id, count, price }) => (
                <DartItem
                  key={id}
                  id={id}
                  count={count}
                  price={price}
                  handlePurchase={() => handlePurchase(id, count, price)}
                />
              ))}
            </DartPackageList>
          </div>
        </FlexStack>
      </Container>
    </>
  );
}

export const Container = styled.div`
  display: flex;
  position: relative;
  flex-direction: column;
  gap: 24px;
  width: 100%;
  height: 100%;
  padding: 0px 16px;
`;

export const DartBannerBox = styled.div`
  display: block;
  width: 100%;
`;

export const DartBanner = styled.img`
  width: 100%;
  border-radius: 16px;
`;

export const SubTitle = styled.h3`
  ${({ theme }) => css`
    display: block;
    margin-bottom: 16px;
    color: ${theme.content.content_light_1};
    ${theme.fontStyle.poppins.desc2_bold}
  `}
`;

export const DartPackageList = styled.ul`
  display: flex;
  flex-direction: column;
  gap: 8px;
`;

export const TopContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  height: fit-content;
`;

const DartContainer = styled.div`
  display: flex;
  gap: 7px;
  align-items: center;
`;

export const DartIcon = styled.img`
  /* display: block; */
  width: 24px;
  height: 22px;
`;
